import { render, staticRenderFns } from "./newExamTopicTable.vue?vue&type=template&id=64ec185a"
import script from "./newExamTopicTable.vue?vue&type=script&lang=js"
export * from "./newExamTopicTable.vue?vue&type=script&lang=js"
import style0 from "./newExamTopicTable.vue?vue&type=style&index=0&id=64ec185a&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports